import {
  CreateSchedulingsForQuestionnaireDTO,
  QuestionnaireSchedulingDTO,
} from '@aphp-ema/common/scheduling';
import { convertTimeToMinutes } from '@aphp-ema/common/utils/time';

export const schedulingOverlapValidator = (
  schedulingForm: CreateSchedulingsForQuestionnaireDTO,
) => {
  const { schedulings, configuration } = schedulingForm;

  const specificDaysSchedulings = Object.groupBy(schedulings, (s) => s.day);

  for (const [_day, daySchedulings] of Object.entries(
    specificDaysSchedulings,
  )) {
    const isValid = daySchedulingOverlapValidator(
      daySchedulings,
      configuration.validityInMinutes,
    );

    if (!isValid.isValid) {
      return isValid;
    }
  }

  return { isValid: true };
};

const daySchedulingOverlapValidator = (
  schedulings: QuestionnaireSchedulingDTO[],
  validityInMinutes: number,
) => {
  if (schedulings.length === 0) {
    return { isValid: true };
  }

  const sortedSchedulings = [...schedulings].sort((a, b) => {
    return a.startTime.localeCompare(b.startTime);
  });

  for (let i = 0; i < sortedSchedulings.length - 1; i++) {
    const currentScheduling = sortedSchedulings[i];
    const nextScheduling = sortedSchedulings[i + 1];

    const currentEndTime =
      currentScheduling.endTime || currentScheduling.startTime;

    const currentEndMinutes = convertTimeToMinutes(currentEndTime);

    const nextStartMinutes = convertTimeToMinutes(nextScheduling.startTime);

    const nextAvailableStartMinutes = currentEndMinutes + validityInMinutes;

    if (nextAvailableStartMinutes > nextStartMinutes) {
      return {
        isValid: false,
      };
    }
  }

  return { isValid: true };
};
